<template> 
       
        <v-dialog
            v-model="show"
            width="100%"            
            persistent>
            <v-card 
                color="transparent"
                height="600"
                flat>
                <v-card-text>
                    <v-container fluid>
                        <v-layout col class="align-center">
                            <v-flex class="text-xs-center align-center">
                                <v-progress-circular
                                    :size="300"
                                    :width="20"
                                    color="grey darken-4"
                                    indeterminate
                                ></v-progress-circular>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
            
        </v-dialog>                                            
</template>
<script>
    
    export default {   
    name: "formstopperdialog",
    props: [
        "show"
    ],
    
    
}
</script>
